module.exports = __webpack_public_path__ + "img/sec3_img.995a079f.png";